export const elements = ["gold", "wood", "water", "fire", "soil"];
